module.exports = __webpack_public_path__ + "static/media/German_Karl BG-29.adfacdb2.png";